module.exports = __webpack_public_path__ + "835bdf24a1d271d58994508f77997f37.webm";


//////////////////
// WEBPACK FOOTER
// ./src/components/cover/cover-desktop.webm
// module id = 261
// module chunks = 1